module.exports = __webpack_public_path__ + "static/media/CM-marca_reduzida-sobre-verde-RGB.d3c5d0dc.svg";